<template>
  <v-container>
    <v-layout justify-center>
      <v-flex>
        <v-card :loading="!direct_login_failed">
          <v-card-text class="text-center">
            <h3>{{$t('directLogin.signIn')}}</h3>
          </v-card-text>
          <v-card-text class="text-center" v-if="direct_login_failed">
            {{$t('directLogin.directLoginFail')}}
          </v-card-text>
          <v-card-actions>
            <v-btn v-on:click="goBack" color="primary">{{ $t('backButton') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import router from '@/router';
  import _ from 'lodash'
  export default {
    name: 'direct-login',
    data() {
      return {
        magic_link_token: null,
        direct_login_failed: false,
        loading: false
      };
    },
    methods: {
      goBack() {
        router.push({
          'name': 'signin'
        });
      },
      async checkMagicLinkTokenValidity() {
        this.loading = true;
        try {
          await this.$store.dispatch(`directLinkLogin`, {
            magic_link_token: this.magic_link_token
          });
          let redirect = this.$route.params['redirect'];
          if (redirect) {
            let redirect_params = _.omit(this.$route.params, ['token', 'redirect'])
            router.push({
              path: redirect,
              query: redirect_params
            });
          } else {
            router.push({
              'name': 'home'
            });
          }
        } catch (error) {
          console.error('error')
          this.direct_login_failed = true;
        } finally {
          this.loading = false;
        }
      }
    },
    mounted() {
      this.magic_link_token = this.$route.params['token']
      if (this.magic_link_token) {
        this.checkMagicLinkTokenValidity()
      } else {
        router.push({
          'name': 'signin'
        })
      }
    }
  };
</script>
